import React from "react";
import { Link } from "react-router-dom"
import styled from "styled-components";
import {isMobile} from 'react-device-detect';

import logo from "../images/logo.png"
import ontour from "../images/mas-on-tour.png"
import donatenow from "../images/donatenow.gif"

import Container from "./container"

import colors from "../settings/colors"

const Header = styled.header`
    display: flex;
    gap: 10px;
    margin-top: ${isMobile ? 50:0}px;
    flex-flow: ${isMobile ? "column":"unset"};

    > div {
        flex-basis: 50%;
        flex: 1;
    }
`
const Donate = styled.div`
    background-color: ${colors.green};
    padding: 20px;
    margin: 0px;
    
    font-size: 90%;

    h2 {
        margin-top: 0px;
    }

    img {
        display: block;
        margin: 0px auto;
    }

    div.link {
        padding: 10px;
        background-color: rgba(255,255,255,.1);
        border-radius: 5px;
        float: right;
        margin: 0px 0px 10px 15px;

        &:hover {
            background-color: rgba(255,255,255,.3);
        }
    }
    a.donate {
        display: block;
        text-decoration: none;
        padding: 5px;
        text-align: center;
        font-weight: bold;
        color: white;
        font-size: 125%;
    }
`
const Logo = styled.div`
    padding: 0px;
`

function SiteHeader(props) {

  return (
    <Container>
    <Header page={props.page}>
        <Logo>
            <Link to="/">
                <img id="logo" src={logo} width="350" alt="Marshall Artists Series" />
            </Link>
            <div style={{
                marginTop: "15px",
                backgroundColor: colors.orange,
                padding: "10px",
            }}>
                {/* <img src={ontour} alt="MAS On Tour" width="60" />
                <p>
                    Beginning this season, The Keith Albee Performing Arts Center will close temporarily (at times) and Marshall Artists Series events will take place at different venues.  These changes have allowed us o provide a fall season with spring events to be named later. 
                </p> */}

                <div style={{fontSize: "125%"}}><strong>TICKETING INFO</strong></div>
                <p>
                    Ticketmaster is the only verified online seller of the Marshall Artists Series.
                </p>
                <p>
                    Our venues only accept physical tickets. We are unable to accept print-at-home or mobile tickets.
                </p>
                <p>
                    Any additional questions, call 304.696.6656.
                </p>
            </div>
        </Logo>
        <Donate>
            <div className="link">
                <a href="https://give.marshall.edu/project/26398/donate?des_id=154758" target="_blank" rel="noreferrer">
                    <img src={donatenow} width="100" alt="Donate Now" border="0" /></a>

                <a href="https://give.marshall.edu/project/26398/donate?des_id=154758" target="_blank" rel="noreferrer" className="donate">
                    Make a Donation
                </a>
            </div>            
            <div>
                <div>
                    <h2 style={{marginBottom: "0px"}}>Get Involved</h2>
                    <p style={{marginTop: "5px"}}>
                        <strong>Support</strong> the Marshall Artists Series as An Individual. A Corporation. A Volunteer.
                    </p>                       
                </div>
                <p>
                    <small>
                        Contributions are absolutely critical to fulfilling the Artists Series mission. Ticket sales
                        and other earned income cannot completely cover the costs of underwriting our
                        numerous programs. Only private funds can make these programs possible.
                    </small>
                </p>
                <p>
                    For more information on how you can get involved call our office 
                    at <strong>304.696.3326</strong>.
                </p>
            </div>
        </Donate>           
    </Header>
    </Container> 
  );
}

export default SiteHeader;